import styled from 'styled-components';

export const StatisticsWrapper = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 32px 32px 20px 32px;
  gap: 32px;
  background: ${({ theme }) => theme.color.background};
  overflow-y: auto;
  height: 100%;

  > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > h1 {
      color: ${({ theme }) => theme.color.grey900};
      font-size: 28px;
      line-height: 39.2px;
      letter-spacing: 0.28px;
      text-transform: capitalize;
    }
  }
`;
